// extracted by mini-css-extract-plugin
module.exports = {"container":"Dot_container__1tLGi","dot":"Dot_dot__wcIb5","clickable":"Dot_clickable__y7vL1"};